if (typeof window.updateHeaderCartBubble !== 'function') {
  window.updateHeaderCartBubble = function updateHeaderCartBubble() {
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (!cartIconBubble) return Promise.resolve();

    return fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const count = Number(cart.item_count) || 0;
        let bubble = cartIconBubble.querySelector('.cart-count-bubble');

        if (count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            cartIconBubble.appendChild(bubble);
          }

          const ariaCount = count < 100 ? String(count) : '99+';
          bubble.innerHTML = `
            <span aria-hidden="true">${ariaCount}</span>
            <span class="visually-hidden">${count} items</span>
          `;
          bubble.style.display = '';
        } else if (bubble) {
          bubble.style.display = 'none';
        }
      })
      .catch(() => {});
  };
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;

        // Old theme: single click -> one /cart/add.js (Rebuy 103359 hooks that once).
        // Dawn form submit + Rebuy click = addon added twice in drawer.
        this.hasRebuyAddon = !!document.querySelector('[data-rebuy-id="103359"]');
        if (this.hasRebuyAddon) {
          this.onSubmitHandlerBound = this.onSubmitHandler.bind(this);
          this.submitButton.addEventListener('click', this.onSubmitHandlerBound);
        } else {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || !this.form) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this._isAddingToCart) return;
        this._isAddingToCart = true;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');

        const config =
          typeof window.fetchConfig === 'function'
            ? window.fetchConfig('javascript')
            : {
                method: 'POST',
                headers: {
                  Accept: 'application/javascript',
                },
              };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
         if (typeof window.appendMonogramRoutingProperties === 'function') {
          window.appendMonogramRoutingProperties(formData);
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const cartAddUrl = ((window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add') + '.js';
        fetch(cartAddUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.updateHeaderCartBubble();
              return;
            }

            const startMarker =
              typeof CartPerformance !== 'undefined' && CartPerformance.createStartingMarker
                ? CartPerformance.createStartingMarker('add:wait-for-subscribers')
                : null;
            if (!this.error && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                if (startMarker && typeof CartPerformance !== 'undefined' && CartPerformance.measureFromMarker) {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                }
              });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (typeof CartPerformance !== 'undefined' && CartPerformance.measure) {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                      });
                    } else {
                      this.cart.renderContents(response);
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (typeof CartPerformance !== 'undefined' && CartPerformance.measure) {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                  window.updateHeaderCartBubble();
                });
              } else {
                this.cart.renderContents(response);
                window.updateHeaderCartBubble();
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this._isAddingToCart = false;
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const loadingSpinner = this.querySelector('.loading__spinner');
            if (loadingSpinner) loadingSpinner.classList.add('hidden');

            if (typeof CartPerformance !== 'undefined' && CartPerformance.measureFromEvent) {
              CartPerformance.measureFromEvent("add:user-action", evt);
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// Fallback: if any product add-to-cart form is not wrapped by <product-form>,
// force AJAX add like collection quick-add (no redirect/reload).
document.addEventListener(
  'submit',
  function (evt) {
    const form = evt.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (form.closest('product-form')) return;
    if (form.dataset.ajaxAtcBound === 'true') return;

    evt.preventDefault();

    const submitButton = form.querySelector('[type="submit"]');
    const loadingSpinner = form.querySelector('.loading__spinner');
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;
    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
    }
    if (loadingSpinner) loadingSpinner.classList.remove('hidden');

    const config = {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
    };
    const formData = new FormData(form);
     if (typeof window.appendMonogramRoutingProperties === 'function') {
      window.appendMonogramRoutingProperties(formData);
    }
    if (form.matches('[data-quick-view-form]') && typeof window.applyQuickViewMonogramProperties === 'function') {
      window.applyQuickViewMonogramProperties(formData, form.closest('modal-dialog'));
    }
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;

    const cartAddUrl = ((window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(cartAddUrl, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) return;
        if (cart && typeof cart.renderContents === 'function') {
          const sectionIds = cart.getSectionsToRender().map((section) => section.id);
          return fetch(window.location.pathname + '?sections=' + sectionIds.join(','))
            .then((sectionRes) => sectionRes.json())
            .then((sectionsPayload) => {
              cart.renderContents({
                id: response.id,
                sections: sectionsPayload,
              });
              window.updateHeaderCartBubble();
            })
            .catch(() => {
              window.updateHeaderCartBubble();
              if (typeof cart.open === 'function') cart.open();
            });
        }
        window.updateHeaderCartBubble();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
        if (loadingSpinner) loadingSpinner.classList.add('hidden');
      });
  },
  true
);
